import * as React from 'react';

import { cn } from '@/hen-ui/utils/index';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return <input type={type} className={cn(className)} ref={ref} {...props} />;
  },
);
Input.displayName = 'Input';

export { Input };
